import { render } from "./CategoryRow.vue?vue&type=template&id=2eef5832&scoped=true"
import script from "./CategoryRow.vue?vue&type=script&lang=js"
export * from "./CategoryRow.vue?vue&type=script&lang=js"

import "./CategoryRow.vue?vue&type=style&index=0&id=2eef5832&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eef5832"]])

export default __exports__